import type { PermissionDomainKey, PermissionOperation } from './policy'

export type AuthorizationConstraintReason = 'system'

export type AuthorizationConstraint = {
  reason: AuthorizationConstraintReason
  lockedValue: boolean
}

export type AuthorizationConstraints = {
  booleans?: Partial<
    Record<
      'canInviteTeamMember' | 'canManageOrganization',
      AuthorizationConstraint
    >
  >
  domains?: Partial<
    Record<
      PermissionDomainKey,
      Partial<Record<PermissionOperation, AuthorizationConstraint>>
    >
  >
}

export const EMPTY_AUTHORIZATION_CONSTRAINTS: AuthorizationConstraints = {}

export const resolveAuthorizationConstraints = (_params: {
  role: string
  template?: string | null
  isRotor?: boolean
}): AuthorizationConstraints => EMPTY_AUTHORIZATION_CONSTRAINTS
